export const testnet = process.env.REACT_APP_CHAIN_ID > 1;
//export const testnet = true;
export const environment = process.env?.REACT_APP_ENVIRONMENT_NAME;

export const LOYALAddress = testnet
  ? "0x84494BcD15BFcB1bb0c1587079935F09e34d61C7"
  : "0xEdA4F23957d2F819c22761C4d6D6157bd3fE0724";

export const GDAOAddress = testnet
  ? "0xd326bbd1b7d0fcc48e83279acb842df93b03fb2e"
  : "0x515d7E9D75E2b76DB60F8a051Cd890eBa23286Bc";


let poeAddr = "";
if (environment === "ycsm-dev") {
  poeAddr = "0x36c81CEf9d311Dcf46391e9cF8A776e9991946A3";
} else if (environment === "ycsm-prod") {
  poeAddr = "0x5945baf9272e0808165adea61b932ec1604fb161";
} else if (testnet) {
  poeAddr = "0x36c81cef9d311dcf46391e9cf8a776e9991946a3";
} else {
  poeAddr = "0x36c81cef9d311dcf46391e9cf8a776e9991946a3";
}
console.log(`Token Environment: ${environment} POE address: ${poeAddr}`);
export const POEAddress = poeAddr;

export const NFTClaimAddress = testnet
  ? "0x364987e14c8c1fe25d34e456cd0a90e9c620b4d8"
  : "0x364987e14c8c1fe25d34e456cd0a90e9c620b4d8";

export const NFTSaleAddress = testnet
  ? "0xc427c4f833a398d6b0904650c798590ff8711360"
  : "0xed01293842cc43a7197c95b6e986b7f66abaad80";